import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=58a66ae4&scoped=true"
import script from "./TasksTable.vue?vue&type=script&lang=js"
export * from "./TasksTable.vue?vue&type=script&lang=js"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=58a66ae4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a66ae4",
  null
  
)

export default component.exports